/**
 * @Author: wuyang
 * @Date: 2024/1/10
 * @Description: ""
 */
import { useAtomMethod } from '@/helper/hooks/atom-method-hook/useAtomMethod'
import { userinfoService } from '@/common/services/userinfo/userinfoService'

export const DataXFooter = () => {
	const [businessInfo] = useAtomMethod(userinfoService.businessInfo)
	return (
		<div
			className={
				'h-[60px] bg-primary text-white text-center text-[12px] mt-[0px] flex items-center justify-center'
			}
		>
			<div>
				{businessInfo?.name}&nbsp;&nbsp;
				<a
					href="https://beian.miit.gov.cn/#/Integrated/index"
					target="_blank"
					rel="noopener noreferrer"
				>
					{businessInfo?.recordNumber}
				</a>
			</div>
		</div>
	)
}
